import {collection, EntityData, field} from "@fedeltapointofsale/data-client";
import {StockCostingType} from "./stock-costing-type";
import {Markup_Type} from "../../pricing/markup/markup.data";
import {TaxReferenceData} from "../../system/tax/tax.data";
import {ProductLineItemData} from "../../catalogue/product-line/product-line.data";
import {ProductPriceLevelData} from "../../catalogue/sellable/sellable.data";
import {CompositeProductComponentData} from "../../catalogue/composite-product/composite-product.data";

export class CostedInventoryQuantity extends EntityData<CostedInventoryQuantity> {
    @field amount: number;
    @field inventoryId: number;
    @field measureId: number;
    @field measureAmt: number;
    @field cost: number;

    public static fromProductLineItem(productLineItem: ProductLineItemData): CostedInventoryQuantity {
        const costedInventoryQuantity: CostedInventoryQuantity = <CostedInventoryQuantity> EntityData.create(CostedInventoryQuantity);
        costedInventoryQuantity.amount = productLineItem.amount;
        costedInventoryQuantity.inventoryId = productLineItem.inventory.inventoryId;
        costedInventoryQuantity.measureId = productLineItem.stockSize.measure.measureId;
        costedInventoryQuantity.measureAmt = productLineItem.stockSize.measureAmt;
        return costedInventoryQuantity;
    }
}

export class CostedCompositeComponent extends EntityData<CostedCompositeComponent> {
    @field sellableId: number;
    @field plgId: number;

    public static fromCompositeProductComponent(component: CompositeProductComponentData): CostedCompositeComponent {
        const costedCompositeComponent: CostedCompositeComponent = <CostedCompositeComponent> EntityData.create(CostedCompositeComponent);
        costedCompositeComponent.sellableId = component.productLine ? component.productLine.sellableId : null;
        costedCompositeComponent.plgId = component.plg ? component.plg.plgId : null;
        return costedCompositeComponent;
    }
}

export class PriceLevelPricing extends EntityData<PriceLevelPricing> {
    @field priceLevelId: number;
    @field priceLevelName: string;
    @field markupType: Markup_Type;
    @field markupValue: number;
    @field priceEx: number;
    @field priceInc: number;
    @field profit: number;
    @field margin: number;

    public static fromProductPriceLevel(productPriceLevel: ProductPriceLevelData): PriceLevelPricing {
        const pricing = <PriceLevelPricing> EntityData.create(PriceLevelPricing);
        pricing.priceLevelId = productPriceLevel.priceLevel.priceLevelId;
        pricing.priceLevelName = productPriceLevel.priceLevel.name;
        pricing.markupType = productPriceLevel.markup.type;
        pricing.markupValue = productPriceLevel.markup.value;
        return pricing;
    }
}

export class StockCosting extends EntityData<StockCosting> {
    @field costingType: StockCostingType;
    @field outletId: number;
    @field basePrice: number;
    @field baseCostEx: number;
    @field totalCost: number;
    @collection(CostedInventoryQuantity) inventoryQuantities: CostedInventoryQuantity[];
    @collection(CostedCompositeComponent) compositeComponents: CostedCompositeComponent[];
    @collection(TaxReferenceData) taxes: TaxReferenceData[];
    @collection(PriceLevelPricing) pricings: PriceLevelPricing[];
}
